import { IconArrowRight, IconCheck } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import styles from './ShareSettlementStatus.module.scss';
import { Props } from './ShareSettlementStatus.types';

/**
 * Ce qu'il reste à savoir d'une part une fois les règles de remboursement appliquées :
 * réglée et par qui, ou due à quelqu'un d'autre que le payeur.
 *
 * Ne rend rien pour une part simplement due au payeur — c'est le cas courant, et l'afficher
 * mettrait une ligne de bruit sous chaque participant.
 */
const ShareSettlementStatus = ({ share }: Props) => {
  const { t } = useTranslation();

  if (share.settledAt) {
    const transfer = share.settledByTransfer;
    const on = dayjs(share.settledAt).format('DD/MM/YYYY');

    return (
      <div className={`${styles.container} ${styles.settled}`}>
        <IconCheck size={14} />
        {transfer?.fromName
          ? t(
              'expenses.share.settledByWithName',
              'Réglée le {{date}} via le remboursement de {{name}}',
              {
                date: on,
                name: transfer.fromName,
              }
            )
          : t('expenses.share.settledOn', 'Réglée le {{date}}', { date: on })}
      </div>
    );
  }

  const creditorName = share.owedToUser
    ? [share.owedToUser.firstName, share.owedToUser.lastName].filter(Boolean).join(' ')
    : share.owedToPlaceholderMember
      ? [share.owedToPlaceholderMember.firstName, share.owedToPlaceholderMember.lastName]
          .filter(Boolean)
          .join(' ')
      : (share.owedToBankAccount?.name ?? null);

  if (!creditorName) return null;

  return (
    <div className={`${styles.container} ${styles.moved}`}>
      <IconArrowRight size={14} />
      {t('expenses.share.owedTo', 'À régler à {{name}}', { name: creditorName })}
    </div>
  );
};

export default ShareSettlementStatus;
